// 9fbef606107a605d69c0edbcd8029e5d 
const LoyaltyUserConstants = {
  PLCC_USER: 'PLCC',
  MPR_USER: 'MPR',
  GUEST_USER: 'Guest',
};

export default LoyaltyUserConstants;
